import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { toast, ToastContainer } from "react-toastify";
import MicroModal from "micromodal";

import Typography from "../../Typography";
import "./comparasions.css";
import StackedBarChart from "./StackedBarChart/StackedBarChart";
import SimpleBarChart from "./SimpleBarChart/SimpleBarChart";
import { format } from "date-fns";
import {
  getComparisonsNPS,
  getComparisonsNpsXServices,
  getComparisonsProfile,
  getEngagement,
  getGradeAverage,
  getSearchSended,
} from "../../../services/nps/functions";
import StackedBarChartSearch from "./StackedBarChartSearch/StackedBarChartSearch";
import Dots from "../../Loading/Dots/Dots";
import Paperplane from "../../Loading/Paperplane/Paperplane";
import MetaValueModal from "../../modals/MetaValueModal";
import TextSmall from "../../manager-section/TextComponent/TextSmall";
import { useLocalStorage } from "../hooks/useLocalStorage";

import { ReactComponent as EditMetaIcon } from "../../../build/images/editmeta.svg";
import { ReactComponent as GoalIcon } from "../../../build/images/iconmeta.svg";
import { ReactComponent as HamburgerIcon } from "../../../build/images/nps-dashboard-icons/hamburger.svg";
import MetaValueModalV2 from "../../modals/MetaValueModalV2";

const fakeSimpleBarData = [
  {
    name: "JAN",
    currentYearData: 2,
    lastYearData: 3,
    goal: 5,
  },
  {
    name: "FEV",
    currentYearData: 7,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "MAR",
    currentYearData: 3,
    lastYearData: 4,
    goal: 5,
  },
  {
    name: "ABR",
    currentYearData: 4,
    lastYearData: 5,
    goal: 5,
  },
  {
    name: "MAI",
    currentYearData: 2,
    lastYearData: 3,
    goal: 5,
  },
  {
    name: "JUN",
    currentYearData: 1,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "JUL",
    currentYearData: 0,
    lastYearData: 1,
    goal: 5,
  },
  {
    name: "AGO",
    currentYearData: 1,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "SET",
    currentYearData: 2,
    lastYearData: 1,
    goal: 5,
  },
  {
    name: "OUT",
    currentYearData: 2,
    lastYearData: 3,
    goal: 5,
  },
  {
    name: "NOV",
    currentYearData: 1,
    lastYearData: 2,
    goal: 5,
  },
  {
    name: "DEZ",
    currentYearData: 0,
    lastYearData: 1,
    goal: 5,
  },
];

const fakeStackedBarData = [
  {
    name: "JAN",
    currentYearDetractor: 2,
    currentYearNeutral: 3,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "FEV",
    currentYearDetractor: 1,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "MAR",
    currentYearDetractor: 3,
    currentYearNeutral: 4,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "ABR",
    currentYearDetractor: 4,
    currentYearNeutral: 5,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "MAI",
    currentYearDetractor: 2,
    currentYearNeutral: 3,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "JUN",
    currentYearDetractor: 1,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "JUL",
    currentYearDetractor: 0,
    currentYearNeutral: 1,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "AGO",
    currentYearDetractor: 3,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "SET",
    currentYearDetractor: 0,
    currentYearNeutral: 1,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "OUT",
    currentYearDetractor: 2,
    currentYearNeutral: 3,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "NOV",
    currentYearDetractor: 1,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "DEZ",
    currentYearDetractor: 0,
    currentYearNeutral: 1,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
];

export default function Comparisons() {
  //REDUX - Selectors
  const filtersDashboard = useSelector((state) => state.npsfilters);

  //STATES
  const [initialDate, setInitialDate] = useState(
    filtersDashboard.datestartComparisons
  );
  const [finalDate, setFinalDate] = useState(
    filtersDashboard.dateendComparisons
  );
  const [businessIds, setBusinessIds] = useState(filtersDashboard.business);
  const [unitsIds, setUnitsIds] = useState(filtersDashboard.units);
  const [profile, setProfile] = useState(filtersDashboard.comparison);
  const [simpleBarData, setSimpleBarData] = useState(fakeSimpleBarData);
  const [stackedBarData, setStackedBarData] = useState(fakeStackedBarData);
  const [currentYear, setCurrentYear] = useState(
    getYear(
      "current",
      filtersDashboard.datestartComparisons,
      filtersDashboard.dateendComparisons
    )
  );
  const [lastYear, setLastYear] = useState(
    getYear(
      "last",
      filtersDashboard.datestartComparisons,
      filtersDashboard.dateendComparisons
    )
  );

  const [dataToNPSGraphic, setDataToNPSGraphic] = useState(null);
  const [dataToGradeAverageGraphic, setDataToGradeAverageGraphic] =
    useState(null);
  const [dataToEngagementGraphic, setDataToEngagementGraphic] = useState(null);
  const [dataToProfileGraphic, setDataToProfileGraphic] = useState(null);
  const [dataToSearchSendedGraphic, setDataToSearchSendedGraphic] =
    useState(null);
  const [dataToNPSXServicesGraphic, setDataToNPSXServicesGraphic] =
    useState(null);
  const [loadingNPSGraphic, setLoadingNPSGraphic] = useState(false);
  const [loadingGradeAverageGraphic, setLoadingGradeAverageGraphic] =
    useState(false);
  const [loadingEngagementGraphic, setLoadingEngagementGraphic] =
    useState(false);
  const [loadingProfileGraphic, setLoadingProfileGraphic] = useState(false);
  const [loadingSearchSendedGraphic, setLoadingSearchSendedGraphic] =
    useState(false);
  const [loadingNPSXServicesGraphic, setLoadingNPSXServicesGraphic] =
    useState(false);
  const [NPSXServicesError, setNPSXServicesError] = useState(false);
  const [searchSendedError, setSearchSendedError] = useState(false);
  const [profileError, setProfileError] = useState(false);
  const [engagementError, setEngagementError] = useState(false);
  const [gradeAverageError, setGradeAverageError] = useState(false);
  const [NPSError, setNPSError] = useState(false);
  const [metaValue, setMetaValue] = useState(getMetaValue());
  const [value, setValue] = useState(getMetaValue());

  //FUNCTIONS
  function updateGoalOnNPS(goal, dataToNPSGraphic) {
    let copyOfData = null;
    let dataToUpdate = null;
    if (dataToNPSGraphic) {
      if (dataToNPSGraphic.length) {
        copyOfData = dataToNPSGraphic.slice();
        dataToUpdate = copyOfData.map((data) => {
          return { ...data, goal: goal };
        });
      } else {
        copyOfData = [];
        dataToUpdate = [];
      }
    }
    return dataToUpdate;
  }

  function getMetaValue() {
    const [storedValue, setStoredValue] = useLocalStorage("ingWebNPS_goal", 0);
    let goal = 0;
    if (storedValue) {
      goal = storedValue;
    }
    return goal;
  }

  const OpenModalMeta = () => {
    setValue(metaValue);
    MicroModal.show("modal__edit_meta_value");
  };

  const handleMetaValue = () => {
    setMetaValue(value);
    //localStorage.setItem("ingWebNPS_goal", value);
    MicroModal.close("modal__edit_meta_value");
  };

  function getYear(type, datestart, dateend) {
    const lastYear = format(new Date(datestart), "yyyy");
    const currentYear = format(new Date(dateend), "yyyy");
    const dateStartDateFormat = new Date(datestart);
    if (lastYear === currentYear) {
      let updatedLastYear = new Date(datestart);
      updatedLastYear.setFullYear(dateStartDateFormat.getFullYear() - 1);
      updatedLastYear = format(new Date(updatedLastYear), "yyyy");
      switch (type) {
        case "last":
          return updatedLastYear;
        case "current":
          return currentYear;
        default:
          return;
      }
    } else {
      switch (type) {
        case "last":
          return lastYear;
        case "current":
          return currentYear;
        default:
          return;
      }
    }
  }
  function getMonthIndex(monthNumber) {
    switch (monthNumber) {
      case "01":
        return 0;
      case "02":
        return 1;
      case "03":
        return 2;
      case "04":
        return 3;
      case "05":
        return 4;
      case "06":
        return 5;
      case "07":
        return 6;
      case "08":
        return 7;
      case "09":
        return 8;
      case "10":
        return 9;
      case "11":
        return 10;
      case "12":
        return 11;
      default:
        return 0;
    }
  }

  async function updateNPSXServicesGraphic(
    yearStart,
    yearEnd,
    businessId = "",
    unityId = "",
    profile = ""
  ) {
    setLoadingNPSXServicesGraphic(true);
    const rawData = await getComparisonsNpsXServices(
      yearStart,
      yearEnd,
      businessId,
      unityId,
      profile
    );

    if (rawData === "ERROR") {
      setNPSXServicesError(true);
      setDataToNPSXServicesGraphic([]);
      setLoadingNPSXServicesGraphic(false);
      return;
    } else {
      setNPSXServicesError(false);
    }

    let dataToRender = [];

    function putDataInMonth(rawData, goal = 90) {
      let graphicData = [
        {
          name: "JAN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "FEV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "ABR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAI",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUL",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "AGO",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "SET",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "OUT",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "NOV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "DEZ",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
      ];

      rawData.forEach((data) => {
        const date = data.data_nps.split("-");
        const result = data.qtde_procedimentos
          ? Number(data.qtde_procedimentos)
          : 0;
        const monthNumber = date && date.length ? date[1] : "01";
        const yearNumber = date && date.length ? date[0] : "2024";
        let isCurrentYear = false;
        if (yearNumber === currentYear) {
          isCurrentYear = true;
        }
        const indexOfMonth = getMonthIndex(monthNumber);
        if (isCurrentYear) {
          graphicData[indexOfMonth].currentYearData =
            graphicData[indexOfMonth].currentYearData + result;
        } else {
          graphicData[indexOfMonth].lastYearData =
            graphicData[indexOfMonth].lastYearData + result;
        }
      });
      return graphicData;
    }
    if (rawData && rawData.length) {
      dataToRender = putDataInMonth(rawData, 93);
    }
    setDataToNPSXServicesGraphic(dataToRender);
    setLoadingNPSXServicesGraphic(false);
    return dataToRender;
  }

  async function updateSearchSendedGraphic(
    yearStart,
    yearEnd,
    businessId = "",
    unityId = ""
  ) {
    setLoadingSearchSendedGraphic(true);
    const rawData = await getSearchSended(
      yearStart,
      yearEnd,
      businessId,
      unityId
    );

    if (rawData === "ERROR") {
      setSearchSendedError(true);
      setDataToSearchSendedGraphic([]);
      setLoadingSearchSendedGraphic(false);
      return;
    } else {
      setSearchSendedError(false);
    }

    let dataToRender = [];

    function putDataInMonth(rawData) {
      let graphicData = [
        {
          name: "JAN",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "FEV",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "MAR",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "ABR",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "MAI",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "JUN",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "JUL",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "AGO",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "SET",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "OUT",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "NOV",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
        {
          name: "DEZ",
          currentYearSended: 0,
          currentYearAnswered: 0,
          lastYearSended: 0,
          lastYearAnswered: 0,
        },
      ];

      rawData.forEach((data) => {
        const date = data.data_nps.split("-");
        const sended = data.enviadas ? Number(data.enviadas) : 0;
        const answered = data.respondidas ? Number(data.respondidas) : 0;
        const monthNumber = date && date.length ? date[1] : "01";
        const yearNumber = date && date.length ? date[0] : "2024";
        let isCurrentYear = false;
        if (yearNumber === currentYear) {
          isCurrentYear = true;
        }
        const indexOfMonth = getMonthIndex(monthNumber);
        if (isCurrentYear) {
          graphicData[indexOfMonth].currentYearSended =
            graphicData[indexOfMonth].currentYearSended + sended - answered;

          graphicData[indexOfMonth].currentYearAnswered =
            graphicData[indexOfMonth].currentYearAnswered + answered;
        } else {
          graphicData[indexOfMonth].lastYearSended =
            graphicData[indexOfMonth].lastYearSended + sended - answered;

          graphicData[indexOfMonth].lastYearAnswered =
            graphicData[indexOfMonth].lastYearAnswered + answered;
        }
      });
      return graphicData;
    }
    if (rawData && rawData.length) {
      dataToRender = putDataInMonth(rawData, 93);
    }

    setDataToSearchSendedGraphic(dataToRender);
    setLoadingSearchSendedGraphic(false);
    return dataToRender;
  }

  async function updateProfileGraphic(
    yearStart,
    yearEnd,
    businessId = "",
    unityId = "",
    profile = ""
  ) {
    setLoadingProfileGraphic(true);
    const rawData = await getComparisonsProfile(
      yearStart,
      yearEnd,
      businessId,
      unityId,
      profile
    );

    if (rawData === "ERROR") {
      setProfileError(true);
      setDataToProfileGraphic([]);
      setLoadingProfileGraphic(false);
      return;
    } else {
      setProfileError(false);
    }

    let dataToRender = [];

    function putDataInMonth(rawData, goal = 90) {
      let graphicData = [
        {
          name: "JAN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "FEV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "ABR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAI",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUL",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "AGO",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "SET",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "OUT",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "NOV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "DEZ",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
      ];

      rawData.forEach((data) => {
        const date = data.data_nps.split("-");
        const result = data.resultado ? Number(data.resultado) : 0;
        const monthNumber = date && date.length ? date[1] : "01";
        const yearNumber = date && date.length ? date[0] : "2024";
        let isCurrentYear = false;
        if (yearNumber === currentYear) {
          isCurrentYear = true;
        }
        const indexOfMonth = getMonthIndex(monthNumber);
        if (isCurrentYear) {
          graphicData[indexOfMonth].currentYearData =
            graphicData[indexOfMonth].currentYearData + result;
        } else {
          graphicData[indexOfMonth].lastYearData =
            graphicData[indexOfMonth].lastYearData + result;
        }
      });
      return graphicData;
    }
    if (rawData && rawData.length) {
      dataToRender = putDataInMonth(rawData, 93);
    }
    setDataToProfileGraphic(dataToRender);
    setLoadingProfileGraphic(false);
    return dataToRender;
  }

  async function updateEngagementGraphic(
    yearStart,
    yearEnd,
    businessId = "",
    unityId = ""
  ) {
    setLoadingEngagementGraphic(true);
    const rawData = await getEngagement(
      yearStart,
      yearEnd,
      businessId,
      unityId
    );

    if (rawData === "ERROR") {
      setEngagementError(true);
      setDataToEngagementGraphic([]);
      setLoadingEngagementGraphic(false);
      return;
    } else {
      setEngagementError(false);
    }

    let dataToRender = [];

    function putDataInMonth(rawData) {
      let graphicData = [
        {
          name: "JAN",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "FEV",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "MAR",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "ABR",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "MAI",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "JUN",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "JUL",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "AGO",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "SET",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "OUT",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "NOV",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
        {
          name: "DEZ",
          currentYearDetractor: 0,
          currentYearNeutral: 0,
          currentYearPromoter: 0,
          lastYearDetractor: 0,
          lastYearNeutral: 0,
          lastYearPromoter: 0,
        },
      ];

      rawData.forEach((data) => {
        const date = data.data_nps.split("-");
        const result = data.qtde ? Number(data.qtde) : 0;
        const monthNumber = date && date.length ? date[1] : "01";
        const yearNumber = date && date.length ? date[0] : "2024";
        let isCurrentYear = false;
        if (yearNumber === currentYear) {
          isCurrentYear = true;
        }
        const indexOfMonth = getMonthIndex(monthNumber);
        if (isCurrentYear) {
          if (data.tipo === "detrator" || data.tipo === "Detrator") {
            graphicData[indexOfMonth].currentYearDetractor =
              graphicData[indexOfMonth].currentYearDetractor + result;
          } else if (data.tipo === "neutro" || data.tipo === "Neutro") {
            graphicData[indexOfMonth].currentYearNeutral =
              graphicData[indexOfMonth].currentYearNeutral + result;
          } else if (data.tipo === "promotor" || data.tipo === "Promotor") {
            graphicData[indexOfMonth].currentYearPromoter =
              graphicData[indexOfMonth].currentYearPromoter + result;
          }
        } else {
          if (data.tipo === "detrator" || data.tipo === "Detrator") {
            graphicData[indexOfMonth].lastYearDetractor =
              graphicData[indexOfMonth].lastYearDetractor + result;
          } else if (data.tipo === "neutro" || data.tipo === "Neutro") {
            graphicData[indexOfMonth].lastYearNeutral =
              graphicData[indexOfMonth].lastYearNeutral + result;
          } else if (data.tipo === "promotor" || data.tipo === "Promotor") {
            graphicData[indexOfMonth].lastYearPromoter =
              graphicData[indexOfMonth].lastYearPromoter + result;
          }
        }
      });
      return graphicData;
    }

    if (rawData && rawData.length) {
      const aux = putDataInMonth(rawData);
      dataToRender = aux.map((data) => {
        const totalCurrentYear =
          data.currentYearDetractor +
          data.currentYearNeutral +
          data.currentYearPromoter;
        const totalLastYear =
          data.lastYearDetractor + data.lastYearNeutral + data.lastYearPromoter;
        const currentDetractorPercent = totalCurrentYear
          ? Number((data.currentYearDetractor / totalCurrentYear).toFixed(2))
          : 0;
        const currentNeutralPercent = totalCurrentYear
          ? Number((data.currentYearNeutral / totalCurrentYear).toFixed(2))
          : 0;
        const currentPromoterPercent = totalCurrentYear
          ? Number((data.currentYearPromoter / totalCurrentYear).toFixed(2))
          : 0;
        const lastDetractorPercent = totalLastYear
          ? Number((data.lastYearDetractor / totalLastYear).toFixed(2))
          : 0;
        const lastNeutralPercent = totalLastYear
          ? Number((data.lastYearNeutral / totalLastYear).toFixed(2))
          : 0;
        const lastPromoterPercent = totalLastYear
          ? Number((data.lastYearPromoter / totalLastYear).toFixed(2))
          : 0;
        return {
          name: data.name,
          currentYearDetractor: currentDetractorPercent
            ? currentDetractorPercent * 100
            : 0,
          currentYearNeutral: currentNeutralPercent
            ? currentNeutralPercent * 100
            : 0,
          currentYearPromoter: currentPromoterPercent
            ? currentPromoterPercent * 100
            : 0,
          lastYearDetractor: lastDetractorPercent
            ? lastDetractorPercent * 100
            : 0,
          lastYearNeutral: lastNeutralPercent ? lastNeutralPercent * 100 : 0,
          lastYearPromoter: lastPromoterPercent ? lastPromoterPercent * 100 : 0,
        };
      });
    }
    setDataToEngagementGraphic(dataToRender);
    setLoadingEngagementGraphic(false);
    return dataToRender;
  }

  async function updateGradeAverageGraphic(
    yearStart,
    yearEnd,
    businessId = "",
    unityId = ""
  ) {
    setLoadingGradeAverageGraphic(true);
    const rawData = await getGradeAverage(
      yearStart,
      yearEnd,
      businessId,
      unityId
    );

    if (rawData === "ERROR") {
      setGradeAverageError(true);
      setDataToGradeAverageGraphic([]);
      setLoadingGradeAverageGraphic(false);
      return;
    } else {
      setGradeAverageError(false);
    }

    let dataToRender = [];
    function putDataInMonth(rawData, goal = 90) {
      let graphicData = [
        {
          name: "JAN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "FEV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "ABR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAI",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUL",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "AGO",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "SET",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "OUT",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "NOV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "DEZ",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
      ];

      rawData.forEach((data) => {
        const date = data.data_nps.split("-");
        const result = data.resultado ? Number(data.resultado) : 0;
        const monthNumber = date && date.length ? date[1] : "01";
        const yearNumber = date && date.length ? date[0] : "2024";
        let isCurrentYear = false;
        if (yearNumber === currentYear) {
          isCurrentYear = true;
        }
        const indexOfMonth = getMonthIndex(monthNumber);
        if (isCurrentYear) {
          graphicData[indexOfMonth].currentYearData =
            graphicData[indexOfMonth].currentYearData + result;
        } else {
          graphicData[indexOfMonth].lastYearData =
            graphicData[indexOfMonth].lastYearData + result;
        }
      });
      return graphicData;
    }
    if (rawData && rawData.length) {
      dataToRender = putDataInMonth(rawData, 93);
    }
    setDataToGradeAverageGraphic(dataToRender);
    setLoadingGradeAverageGraphic(false);
    return dataToRender;
  }

  async function updateNPSGraphic(
    yearStart,
    yearEnd,
    businessId = "",
    unityId = ""
  ) {
    setLoadingNPSGraphic(true);
    const rawData = await getComparisonsNPS(
      yearStart,
      yearEnd,
      businessId,
      unityId
    );

    if (rawData === "ERROR") {
      setNPSError(true);
      setDataToNPSGraphic([]);
      setLoadingNPSGraphic(false);
      return;
    } else {
      setNPSError(false);
    }

    let dataToRender = [];
    function putDataInMonth(rawData, goal = 90) {
      let graphicData = [
        {
          name: "JAN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "FEV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "ABR",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "MAI",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUN",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "JUL",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "AGO",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "SET",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "OUT",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "NOV",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
        {
          name: "DEZ",
          currentYearData: 0,
          lastYearData: 0,
          goal,
        },
      ];

      rawData.forEach((data) => {
        const date = data.data_nps.split("-");
        const result = data.resultado ? Number(data.resultado) : 0;
        const monthNumber = date && date.length ? date[1] : "01";
        const yearNumber = date && date.length ? date[0] : "2024";
        let isCurrentYear = false;
        if (yearNumber === currentYear) {
          isCurrentYear = true;
        }
        const indexOfMonth = getMonthIndex(monthNumber);
        if (isCurrentYear) {
          graphicData[indexOfMonth].currentYearData =
            graphicData[indexOfMonth].currentYearData + result;
        } else {
          graphicData[indexOfMonth].lastYearData =
            graphicData[indexOfMonth].lastYearData + result;
        }
      });
      return graphicData;
    }
    if (rawData && rawData.length) {
      dataToRender = putDataInMonth(rawData, metaValue);
    }
    setDataToNPSGraphic(dataToRender);
    setLoadingNPSGraphic(false);
    return dataToRender;
  }

  //USE EFFECTS
  useEffect(() => {
    const npsDataToUpdate = updateGoalOnNPS(metaValue, dataToNPSGraphic);
    setDataToNPSGraphic(npsDataToUpdate);
  }, [metaValue]);

  useEffect(() => {
    if (NPSXServicesError) {
      toast.error(
        "Não foi possível fazer a sua consulta do gráfico de NPS / Atendimentos no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        }
      );
    }
  }, [NPSXServicesError, filtersDashboard]);

  useEffect(() => {
    if (searchSendedError) {
      toast.error(
        "Não foi possível fazer a sua consulta do gráfico de Pesquisas enviadas / Respondidas no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        }
      );
    }
  }, [searchSendedError, filtersDashboard]);

  useEffect(() => {
    if (profileError) {
      toast.error(
        "Não foi possível fazer a sua consulta do gráfico de Perfil no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        }
      );
    }
  }, [profileError, filtersDashboard]);

  useEffect(() => {
    if (engagementError) {
      toast.error(
        "Não foi possível fazer a sua consulta do gráfico de Engajamento no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        }
      );
    }
  }, [engagementError, filtersDashboard]);

  useEffect(() => {
    if (gradeAverageError) {
      toast.error(
        "Não foi possível fazer a sua consulta do gráfico de Média de notas no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        }
      );
    }
  }, [gradeAverageError, filtersDashboard]);

  useEffect(() => {
    if (NPSError) {
      toast.error(
        "Não foi possível fazer a sua consulta do gráfico de NPS no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        }
      );
    }
  }, [NPSError, filtersDashboard]);

  useEffect(() => {
    let business = "";
    if (businessIds && businessIds.length) {
      const aux = businessIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        business = aux.join(",");
      } else {
        business = aux[0];
      }
    }

    let units = "";
    if (unitsIds && unitsIds.length) {
      const aux = unitsIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        units = aux.join(",");
      } else {
        units = aux[0];
      }
    }

    let typeProfile = "";
    if (profile && profile.length) {
      const aux = profile.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        typeProfile = aux.join(",");
      } else {
        typeProfile = aux[0];
      }
    }

    updateNPSXServicesGraphic(
      lastYear,
      currentYear,
      business,
      units,
      typeProfile ? typeProfile : "PROMOTOR"
    );
  }, [currentYear, lastYear, businessIds, unitsIds, profile]);

  useEffect(() => {
    let business = "";
    if (businessIds && businessIds.length) {
      const aux = businessIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        business = aux.join(",");
      } else {
        business = aux[0];
      }
    }

    let units = "";
    if (unitsIds && unitsIds.length) {
      const aux = unitsIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        units = aux.join(",");
      } else {
        units = aux[0];
      }
    }

    let typeProfile = "";
    if (profile && profile.length) {
      const aux = profile.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        typeProfile = aux.join(",");
      } else {
        typeProfile = aux[0];
      }
    }

    updateProfileGraphic(
      lastYear,
      currentYear,
      business,
      units,
      typeProfile ? typeProfile : "PROMOTOR"
    );
  }, [currentYear, lastYear, businessIds, unitsIds, profile]);

  useEffect(() => {
    let business = "";
    if (businessIds && businessIds.length) {
      const aux = businessIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        business = aux.join(",");
      } else {
        business = aux[0];
      }
    }

    let units = "";
    if (unitsIds && unitsIds.length) {
      const aux = unitsIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        units = aux.join(",");
      } else {
        units = aux[0];
      }
    }

    updateSearchSendedGraphic(lastYear, currentYear, business, units);
  }, [currentYear, lastYear, businessIds, unitsIds]);

  useEffect(() => {
    let business = "";
    if (businessIds && businessIds.length) {
      const aux = businessIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        business = aux.join(",");
      } else {
        business = aux[0];
      }
    }

    let units = "";
    if (unitsIds && unitsIds.length) {
      const aux = unitsIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        units = aux.join(",");
      } else {
        units = aux[0];
      }
    }

    updateEngagementGraphic(lastYear, currentYear, business, units);
  }, [currentYear, lastYear, businessIds, unitsIds]);

  useEffect(() => {
    let business = "";
    if (businessIds && businessIds.length) {
      const aux = businessIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        business = aux.join(",");
      } else {
        business = aux[0];
      }
    }

    let units = "";
    if (unitsIds && unitsIds.length) {
      const aux = unitsIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        units = aux.join(",");
      } else {
        units = aux[0];
      }
    }

    updateGradeAverageGraphic(lastYear, currentYear, business, units);
  }, [currentYear, lastYear, businessIds, unitsIds]);

  useEffect(() => {
    let business = "";
    if (businessIds && businessIds.length) {
      const aux = businessIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        business = aux.join(",");
      } else {
        business = aux[0];
      }
    }

    let units = "";
    if (unitsIds && unitsIds.length) {
      const aux = unitsIds.map((data) => {
        return data.id;
      });
      if (aux.length > 1) {
        units = aux.join(",");
      } else {
        units = aux[0];
      }
    }

    updateNPSGraphic(lastYear, currentYear, business, units);
  }, [currentYear, lastYear, businessIds, unitsIds]);

  useEffect(() => {
    if (filtersDashboard.datestartComparisons) {
      setInitialDate(filtersDashboard.datestartComparisons);
    }
    if (filtersDashboard.dateendComparisons) {
      setFinalDate(filtersDashboard.dateendComparisons);
    }
    if (filtersDashboard.business) {
      setBusinessIds(filtersDashboard.business);
    }
    if (filtersDashboard.units) {
      setUnitsIds(filtersDashboard.units);
    }
    if (filtersDashboard.comparison) {
      setProfile(filtersDashboard.comparison);
    }
  }, [filtersDashboard]);

  useEffect(() => {
    if (initialDate) {
      const yearFromInitialDate = getYear(
        "last",
        filtersDashboard.datestartComparisons,
        filtersDashboard.dateendComparisons
      );
      if (yearFromInitialDate) {
        setLastYear(yearFromInitialDate);
      }
    }

    if (finalDate) {
      const yearFromFinalDate = format(
        new Date(filtersDashboard.dateendComparisons),
        "yyyy"
      );
      if (yearFromFinalDate) {
        setCurrentYear(yearFromFinalDate);
      }
    }
  }, [initialDate, finalDate]);

  return (
    <section className="comparisons">
      <ToastContainer position="top-center" />
      <div className="comparasions__graphics-container">
        <div className="nps-chart-card">
          <header className="nps-chart-card__header">
            <Typography.H5 weight="700" color="gray-180">
              NPS
            </Typography.H5>
            <div
              className="manager-component__card-perfomance__title-itens"
              onClick={() => OpenModalMeta()}
              style={{ cursor: "pointer" }}
            >
              <div>
                <GoalIcon />
              </div>
              <TextSmall text={`Meta de ${metaValue}%`} color="gray" />
              <div>
                <EditMetaIcon />
              </div>
            </div>
          </header>
          <div className="Surveys-sent-answered-chart-card__graphic">
            {loadingNPSGraphic || dataToNPSGraphic === null ? (
              <div className="Surveys-sent-answered-chart-card__graphic__loading">
                <Paperplane />
              </div>
            ) : (
              <SimpleBarChart
                labelCurrentYear="NPS"
                labelLastYear="NPS"
                currentYear={currentYear}
                lastYear={lastYear}
                isGoalActive={true}
                dataStart={dataToNPSGraphic}
              />
            )}
          </div>
        </div>

        <div className="average-grade-chart-card">
          <header className="average-grade-chart-card__header">
            <Typography.H5 weight="700" color="gray-180">
              Média de notas
            </Typography.H5>
            {/*<HamburgerIcon />*/}
          </header>
          <div className="Surveys-sent-answered-chart-card__graphic">
            {loadingGradeAverageGraphic ||
            dataToGradeAverageGraphic === null ? (
              <div className="Surveys-sent-answered-chart-card__graphic__loading">
                <Paperplane />
              </div>
            ) : (
              <SimpleBarChart
                labelCurrentYear="Média de notas"
                currentYear={currentYear}
                lastYear={lastYear}
                labelLastYear="Média de notas"
                dataStart={dataToGradeAverageGraphic}
                isLimitDomainActive={true}
              />
            )}
          </div>
        </div>
      </div>

      <div className="comparasions__graphics-container">
        <div className="engagement-chart-card">
          <header className="engagement-chart-card__header">
            <Typography.H5 weight="700" color="gray-180">
              {"Engajamento (%)"}
            </Typography.H5>
            {/*<HamburgerIcon />*/}
          </header>
          <div className="engagement-chart-card__graphic">
            {loadingEngagementGraphic || dataToEngagementGraphic === null ? (
              <div className="Surveys-sent-answered-chart-card__graphic__loading">
                <Paperplane />
              </div>
            ) : (
              <StackedBarChart
                dataStart={dataToEngagementGraphic}
                currentYear={currentYear}
                lastYear={lastYear}
              />
            )}
          </div>
        </div>

        <div className="profile-chart-card">
          <header className="profile-chart-card__header">
            <Typography.H5 weight="700" color="gray-180">
              Perfil
            </Typography.H5>
            {/*<HamburgerIcon />*/}
          </header>
          <div className="Surveys-sent-answered-chart-card__graphic">
            {loadingProfileGraphic || dataToProfileGraphic === null ? (
              <div className="Surveys-sent-answered-chart-card__graphic__loading">
                <Paperplane />
              </div>
            ) : (
              <SimpleBarChart
                dataStart={dataToProfileGraphic}
                currentYear={currentYear}
                lastYear={lastYear}
                labelCurrentYear={
                  profile && profile.length ? profile[0].name : "Promotor"
                }
                labelLastYear={
                  profile && profile.length ? profile[0].name : "Promotor"
                }
                isLimitDomainActive={true}
              />
            )}
          </div>
        </div>
      </div>

      <div className="comparasions__graphics-container">
        <div className="Surveys-sent-answered-chart-card">
          <header className="Surveys-sent-answered-chart-card__header">
            <Typography.H5 weight="700" color="gray-180">
              {"Pesquisas enviadas / Respondidas (Quantidade)"}
            </Typography.H5>
            {/*<HamburgerIcon />*/}
          </header>
          <div className="Surveys-sent-answered-chart-card__graphic">
            {loadingSearchSendedGraphic ||
            dataToSearchSendedGraphic === null ? (
              <div className="Surveys-sent-answered-chart-card__graphic__loading">
                <Paperplane />
              </div>
            ) : (
              <StackedBarChartSearch
                dataStart={dataToSearchSendedGraphic}
                currentYear={currentYear}
                lastYear={lastYear}
              />
            )}
          </div>
        </div>

        <div className="nps-services-chart-card">
          <header className="nps-services-chart-card__header">
            <Typography.H5 weight="700" color="gray-180">
              NPS / Atendimentos
            </Typography.H5>
            {/*<HamburgerIcon />*/}
          </header>
          <div className="Surveys-sent-answered-chart-card__graphic">
            {loadingNPSXServicesGraphic ||
            dataToNPSXServicesGraphic === null ? (
              <div className="Surveys-sent-answered-chart-card__graphic__loading">
                <Paperplane />
              </div>
            ) : (
              <SimpleBarChart
                dataStart={dataToNPSXServicesGraphic}
                currentYear={currentYear}
                lastYear={lastYear}
                labelCurrentYear={
                  profile && profile.length ? profile[0].name : "Promotor"
                }
                labelLastYear={
                  profile && profile.length ? profile[0].name : "Promotor"
                }
              />
            )}
          </div>
        </div>
      </div>
      <MetaValueModalV2
        handleMetaValue={handleMetaValue}
        setValue={setValue}
        value={value}
        setMetaValue={setMetaValue}
        storageKey="ingWebNPS_goal"
        text="Selecione a meta"
      />
    </section>
  );
}
